/**
 * CPU-only Compute Node Profiles
 *
 * Profiles for CPU-only compute nodes used for workloads that don't require GPUs.
 */

import type { NodeProfile } from '../../types/additional-nodes';

export const DELL_R760_CPU: NodeProfile = {
  id: 'dell-r760-cpu',
  name: 'Dell PowerEdge R760 (CPU-only)',
  role: 'cpu-compute',
  vendor: 'Dell',
  model: 'PowerEdge R760',
  description: '2U dual-socket CPU compute node',
  rackUnits: 2,
  powerKw: 1.5,
  ethernetPorts: 2,
  cpu: {
    sockets: 2,
    model: 'Intel Xeon Platinum 8480+',
    cores: 112,
  },
  memoryGB: 1024,
  storageBays: 16,
  metadata: {
    productUrl: 'https://www.dell.com/en-us/shop/ipovw/poweredge-r760',
    notes: 'Dual-socket general purpose compute server',
  },
};

export const SUPERMICRO_H13DSI_CPU: NodeProfile = {
  id: 'supermicro-h13dsi-cpu',
  name: 'Supermicro H13DSi (CPU-only)',
  role: 'cpu-compute',
  vendor: 'Supermicro',
  model: 'H13DSi-NT',
  description: '2U dual-socket AMD EPYC compute node',
  rackUnits: 2,
  powerKw: 1.4,
  ethernetPorts: 2,
  cpu: {
    sockets: 2,
    model: 'AMD EPYC 9654',
    cores: 192,
  },
  memoryGB: 1536,
  storageBays: 24,
  metadata: {
    notes: 'High core count AMD EPYC platform',
  },
};

export const HPE_DL380_CPU: NodeProfile = {
  id: 'hpe-dl380-cpu',
  name: 'HPE ProLiant DL380 Gen11 (CPU-only)',
  role: 'cpu-compute',
  vendor: 'HPE',
  model: 'ProLiant DL380 Gen11',
  description: '2U dual-socket enterprise compute node',
  rackUnits: 2,
  powerKw: 1.6,
  ethernetPorts: 2,
  cpu: {
    sockets: 2,
    model: 'Intel Xeon Platinum 8480+',
    cores: 112,
  },
  memoryGB: 2048,
  storageBays: 12,
  metadata: {
    notes: 'Enterprise-grade compute platform',
  },
};

export const CUSTOM_CPU: NodeProfile = {
  id: 'custom-cpu',
  name: 'Custom CPU-only Node',
  role: 'cpu-compute',
  vendor: 'Custom',
  model: 'Custom',
  description: 'Custom CPU-only compute node',
  rackUnits: 2,
  powerKw: 1.5,
  ethernetPorts: 2,
};

export const CPU_COMPUTE_PROFILES: readonly NodeProfile[] = [
  DELL_R760_CPU,
  SUPERMICRO_H13DSI_CPU,
  HPE_DL380_CPU,
  CUSTOM_CPU,
] as const;
